import React from "react";
import { motion } from "framer-motion";
import { ShieldCheck, ShieldX } from "lucide-react";

interface VerificationResultBoxProps {
  status: "valid" | "invalid" | null;
  successMessage?: string;
  errorMessage?: string;
}

/**
 * ✅ VerificationResultBox
 * Muestra el resultado visual de una verificación (firma, certificado, etc.)
 */
const VerificationResultBox: React.FC<VerificationResultBoxProps> = ({
  status,
  successMessage = "La firma digital es válida y coincide con el payload.",
  errorMessage = "La firma no es válida o no coincide con el contenido original.",
}) => {
  if (!status) return null;

  const isValid = status === "valid";

  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
      className={`mt-8 flex items-center gap-3 rounded-xl border p-6 shadow-md ${
        isValid
          ? "border-green-500 bg-green-50 dark:bg-green-900/30"
          : "border-red-500 bg-red-50 dark:bg-red-900/30"
      }`}
    >
      {isValid ? (
        <>
          <ShieldCheck className="h-6 w-6 text-green-600 dark:text-green-400" />
          <p className="font-semibold text-green-700 dark:text-green-300">
            {successMessage}
          </p>
        </>
      ) : (
        <>
          <ShieldX className="h-6 w-6 text-red-600 dark:text-red-400" />
          <p className="font-semibold text-red-700 dark:text-red-300">
            {errorMessage}
          </p>
        </>
      )}
    </motion.div>
  );
};

export default VerificationResultBox;
